function FeatureSection({ feature }) {
    return (
        <div className="flex gap-[6px]">
            <div className='size-[15px]'>
                <img className='size-full' src={feature.imageLink} alt={feature.altText} />
            </div>

            <div className="w-[calc(100%-15px)] flex flex-col gap-1">
                <h1 className='font-semibold text-[10px] leading-[18px] text-[#000000]'>{feature.Heading}</h1>

                <p className='font-medium text-[6px] leading-[14px] text-[#666666]'>{feature.Description}</p>
            </div>
        </div>
    );
}

function FeaturesOne({ item }) {
    return (
        <div className='w-full grid grid-cols-2 gap-x-2 gap-y-2 px-4'>
            {item.item.featureItems.map((feature, index) => {
                return (
                    <FeatureSection 
                        key={index} 
                        feature={feature}
                    />
                )
            })}
        </div>
    );
}

export default FeaturesOne;
